// src/components/About.js
import { Container, Row, Col } from 'react-bootstrap';
import costManagementIcon from '../assets/landing-page-icons/cost-management-icon-white-background.png';
import carrierNetworkIcon from '../assets/landing-page-icons/carrier-network-icon.png';
import analyticsIcon from '../assets/landing-page-icons/analytics-icon.png';
import integrationsIcon from '../assets/landing-page-icons/integrations-icon.png';
import './About.css'; // Import the CSS file

const About = () => {
  return (
    <div className="about-section">
      <h2>Powerful Features for Modern Logistics</h2>
      <p>
        Everything you need to manage your transportation operations efficiently and profitably.
      </p>

      <Container className="fullscreen-section about-container">
        
        <Row className="align-items-center about-container-row">
          <Col md={6} className="about-text-col">
            <h3>Cost Management</h3>
            <p>
              Automate freight auditing, carrier rate management, and comprehensive cost analysis to optimize your spending.
            </p>
          </Col>
          <Col md={6} className="about-image-col">
            <img src={costManagementIcon} alt="cost management icon showing data graph under magnifying glass" className="img-fluid" />
          </Col>
        </Row>

        <Row className="align-items-center about-container-row">
          <Col md={6} className="about-text-col">
            <h3>Carrier Network</h3>
            <p>
              Connect with thousands of verified carriers and get competitive rates through our integrated marketplace.
            </p>
          </Col>
          <Col md={6} className="about-image-col">
            <img src={carrierNetworkIcon} alt="carrier network icon showing a truck on a backdrop of complex graph and nodes" className="img-fluid" />
          </Col>
        </Row>

        <Row className="align-items-center about-container-row">
          <Col md={6} className="about-text-col">
            <h3>Advanced Analytics</h3>
            <p>
              Make data-driven decisions with comprehensive reporting and business intelligence tools.
            </p>
            <p>
              From setting up all your data connections to creating easy to use dashboards and reporting, we can provide a wide range of data analytics services that fit your company's needs.
            </p>
          </Col>
          <Col md={6} className="about-image-col">
            <img src={analyticsIcon} alt="analytics icon showing lots of different data graphs" className="img-fluid" />
          </Col>
        </Row>

        <Row className="align-items-center about-container-row">
          <Col md={6} className="about-text-col">
            <h3>Easy Integration</h3>
            <p>
              Seamlessly connect with your existing ERP, WMS, and other business systems through our robust API platform.
            </p>
            <p>
              We provide custom integration and implementation services - Netsuite integrations and development, API management, Cloud setup/maintenance, data migration, and custom app development.
            </p>
          </Col>
          <Col md={6} className="about-image-col">
            <img src={integrationsIcon} alt="integrations icon showing a collage of different software services" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
